export default {
  name: "Share",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M29 14v13c0 1.16-.84 2-2 2H5c-1.16 0-2-.84-2-2V14c0-.55.45-1 1-1s1 .45 1 1v13h22V14c0-.55.45-1 1-1s1 .45 1 1zM11.71 9.71 15 6.41V20c0 .55.45 1 1 1s1-.45 1-1V6.41l3.29 3.29a.996.996 0 1 0 1.41-1.41l-5-5a.996.996 0 0 0-1.41 0l-5 5c-.39.39-.39 1.02 0 1.41s1.03.4 1.42.01z",
  },
}
